<template>
    <section class="card log-panel col-md-4 offset-md-4 col-10 offset-1 mt-md-0 mt-1">
        <header class="card-header log-panel-header">
            <div class="log-tab py-3"> <!-- py-3 temp untel we get  alogo -->
                <!-- <center><img width="250" alt="Customs logo" src="../assets/full_logo.png" /></center> -->
                <center><img class="logo" width="125" alt="Customs logo" src="../assets/full_logo.png" /></center>
                <br>
                <h5 class="text-dark-emphasis card-title text-center fw-bold">نظام <span class="text-dark">مسافر</span> لتسجيل المركبات عبر المنافذ الحدودية</h5>
            </div>
        </header>
        <section class="card-body px-5">
            <SignForm :formFields="mainFormFields" />
            <!-- <GeneralModal :modalId="'newAppModal'"
                :modalTitle="$t('add_new_req')"
                :modalFormLabel="$t('ent_nat_num')" 
                :inputFields="newAppFields" 
                :modalSubmitFnc="'newModalSubmit'" 
                :dismissable="''"
                /> -->
            <NewApp :modalId="'newAppModal'" :modalTitle="$t('add_new_req')" :modalFormLabel="$t('ent_nat_num')"
                :inputFields="newAppFields" :modalSubmitFnc="'newModalSubmit'" :dismissable="''" />
            <GeneralModal :modalId="'forgetCodeModal'" :modalTitle="'إعادة ضبط رمز التحقق'"
                :modalFormLabel="'املأ اثنين أو أكثر من الحقول التالية لإعادة تعيين رمز التحقق. (رقم الجواز إجباري)'"
                :inputFields="forgetCodeFields" :modalSubmitFnc="'forgetModalSubmit'" />
            <alert-modal ref="alertModal" :redirectUrl="redirectUrl" :alertContent="alertContent"
                :alertSubject="alertSubject" :isDismiss="false" :timeToEnable="2" />
        </section>
    </section>
</template>
<script>
import GeneralModal from "@/components/Modal.vue";
import SignForm from "@/components/Sign/SignForm.vue";
import AlertModal from "@/components/AlertModal.vue";
import NewApp from "@/components/Sign/NewApp.vue";
import { Modal } from 'bootstrap';
import router from '@/router';
import { mapGetters, mapActions } from 'vuex';
export default {
    name: "sign",
    components: {
        SignForm,
        GeneralModal,
        NewApp,
        AlertModal
    },
    data() {
        return {
            newModal: {},
            // newAppFields: [
            //     {
            //         id: "nationNo",
            //         model: "nationNo",
            //         type: "text",
            //         placeholder: this.$t('nat_no'),
            //         required: "required",
            //         pattern: "[0-9]{12}$",
            //         value: ""
            //     },
            //     {
            //         id: "depart",
            //         model: "depart",
            //         type: "select",
            //         placeholder: "اختر المعبر الحدودي",
            //         value: "",
            //         required: "required",
            //         options: [],
            //         optionName: "name",
            //     }
            // ],
            newAppFields: {
                appType: { value: 1 },
                nationNo: { value: null },
                departId: { options: [], value: '' },
                passNo: { value: null },
                nationalityId: { options: [], value: 1 },
            },
            // nationNo: "",
            // checkNo: "",
            mainFormFields: {
                id: "",
                nationNo: "",
                checkNo: "",
            },
            forgetCodeFields: [
                {
                    id: "passNo",
                    model: "passNo",
                    type: "text",
                    placeholder: "رقم جواز سفر",
                    required: "required",
                    value: ""
                },
                {
                    id: "licenseNo",
                    model: "licenseNo",
                    type: "text",
                    placeholder: "رقم الرخصة",
                    required: false,
                    value: ""
                },
                {
                    id: "plateNo",
                    model: "plateNo",
                    type: "text",
                    placeholder: "رقم اللّوحة",
                    required: false,
                    value: ""
                },
                {
                    id: "chassisNo",
                    model: "chassisNo",
                    type: "text",
                    placeholder: "رقم الهيكل",
                    required: false,
                    value: ""
                },
            ],
            alertContent: "",
            alertSubject: "",
            redirectUrl: "1",
        }
    },
    computed: {
        ...mapGetters(['getDeparts','getNationalities']),
    },
    created() {
        this.fetchOptions()
    },
    mounted() {
        this.newModal = new Modal(document.getElementById('newAppModal'));
    },
    methods: {
        ...mapActions([
            'fetchDeparts',
            'fetchNationalities',
        ]),
        ...mapActions(
            'applicantFlow', ['saveApplicant']
        ),
        /**
         * 
         */
        async fetchOptions() {
            if (this.getDeparts.length == 0) {
                await this.fetchDeparts(); // Fetch and store in Vuex
            }
            this.newAppFields.departId.options = this.getDeparts;
            if (this.getNationalities.length == 0) {
                await this.fetchNationalities(); // Fetch and store in Vuex
            }
            this.newAppFields.nationalityId.options = this.getNationalities;
        },
        /********************/
        initNewModal() {
            this.newModal.show()
        },
        /*******************/
        /** */
        async newModalSubmit() {
            const formData = new FormData();
            Object.keys(this.newAppFields).forEach((key) => {
                formData.append(key, this.newAppFields[key].value);
                // reqData[key] = this.formFields[key].value
            });
            try {
                const response = await this.$axios.post("api/applicant/canaddnew", formData);
                const data = response.data;
                if (data.isSuccess) {
                    if(data.hasOwnProperty("applicant") && data?.applicant){
                        this.saveApplicant(data?.applicant)
                    }
                    // modal.hide(); // To close the modal
                    this.$router.push({
                        name: 'applicant',
                        params:
                        {
                            departId: this.newAppFields.departId.value,
                            nationalityId: this.newAppFields.nationalityId.value,
                            appType: this.newAppFields.appType.value,
                            nationNo: this.newAppFields.nationNo.value,
                            passNo: this.newAppFields.passNo.value,

                        }
                    })
                } else {
                    this.$tempAlert(data.msg, 'warning');
                    document.getElementById("nation-no").focus();
                }
            } catch (error) {
                this.$tempAlert(error.response?.data.msg ?? "مشكلة في الاتصال", 'warning');
                console.error("Error fetching options:", error);
            }
            this.newModal.hide(); // To close the modal
        },
        /*****************************/
        /** */
        async forgetModalSubmit() {
            const formData = new FormData();
            this.forgetCodeFields.forEach((field) => {
                formData.append(field.model, field.value);
            });
            try {
                const response = await this.$axios.post("api/applicant/forgetreg", formData);
                const data = response.data;
                if (data.isSuccess) {
                    this.mainFormFields.id = data.applicant.id;
                    this.mainFormFields.checkNo = data.applicant.checkNo;
                    this.redirectUrl = `/updateapp/${this.mainFormFields.id}/${this.mainFormFields.checkNo}`;
                    this.alertSubject = data.msg;
                    this.alertContent = "رقم التحقق هو : " + this.mainFormFields.checkNo;
                } else {
                    this.alertSubject = "فشل العملية";
                    this.alertContent = response.data.msg;
                }
                const alertModalInstance = new Modal(this.$refs.alertModal.$el);
                alertModalInstance.show();
                this.$refs.alertModal.isHidden = 0; // Start the timer
                // setTimeout(() => {
                //     router.push({ name: 'updateApp', params: { id: this.mainFormFields.Id, checkNo : this.mainFormFields.checkNo }})
                // }, 1000)

            } catch (error) {
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg, 'warning');
                }
                console.error("Error fetching options:", error);
            }
        },
        /*****************************/
        /** */
        async inquerySubmit() {
            const formData = new FormData();
            formData.append("nationNo", this.mainFormFields.nationNo)
            formData.append("checkNo", this.mainFormFields.checkNo)
            try {
                const response = await this.$axios.post("api/applicant/checkstatus", formData);
                const data = response.data;
                if (data.isSuccess) {
                    const appStatus = data.applicant.status;
                    if (appStatus == 1 || appStatus == 2) {
                        this.$tempAlert(this.$appStatus[1][appStatus].text, 'success');
                        setTimeout(() => {
                            router.push({ name: 'updateApp', params: { id: data.applicant.id, checkNo: this.mainFormFields.checkNo, status: appStatus} })
                        }, 1000)
                    } else {
                        this.$tempAlert(data.msg, 'warning');
                    }
                } else {
                    this.$tempAlert(data.msg, 'warning');
                }

            } catch (error) {
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg, 'warning');
                }
                console.error("Error fetching options:", error);
            }
        },
        /*****************************/
    }
}
</script>
<style>
.word-logo{
    width: 50vw;
    max-width: 300px;
}
.logo{
    width: 20vw;
    max-width: 200px;
}
</style>